import { createFieldLead } from "@/api/fieldLeads";
import { markFieldLeadSent } from "@/screens/fieldLead/history";
import type { OutboxItem } from "./types";

export async function dispatchItem(item: OutboxItem): Promise<void> {
  const { body } = item.action;
  const receipt = await createFieldLead(body);
  await markFieldLeadSent(body.client_load_id, receipt.id);
}
